import { cisOdataInstance } from './cis-instance';

/** Файлы рабочих чертежей */
export const drawingPackageFileDesc = {
    getHash: (id: string, algoName: string): Promise<string> =>
        cisOdataInstance.get<string>(`DrawingPackagesFileDesc(${id})/GetHash(${algoName})`).then(x => x.data),
};
